@if (forceHiddenElement) {
  <button nbButton class="settings-button" [nbPopover]="menu" nbPopoverPlacement="right" style="background-color: #1a9ca6">
    <fa-icon icon="check-double"></fa-icon>
  </button>
  <ng-template #menu>
    <div class="menu-content" (click)="$event.stopPropagation()">
      @for (menuItem of displayedElementsMenu; track menuItem) {
        <div class="menu-item">
          <nb-checkbox (checkedChange)="menuChanged(menuItem.id)" [checked]="menuItem.value">
            {{ menuItem.label | translate }}
          </nb-checkbox>
        </div>
      }
    </div>
  </ng-template>
}
